(function() {
  "use strict";

  angular.module("SetupAssistant")

    .controller("SetupAssistantController", [
      "$rootScope", "$scope", "$filter", "URLS", "$location", "TenantListService", 
      "APIDownload", "SETUP_ASSISTANT", "PrinterListService", "PRINTER_TYPES", "toastr", 
      "$sce", "EventServiceEvents", 'EventHandlerService',
      function(
        $rootScope, $scope, $filter, URLS, $location, TenantListService, 
        APIDownload, SETUP_ASSISTANT, PrinterListService, PRINTER_TYPES, toastr, 
        $sce, EventServiceEvents, EventHandlerService) {

        $rootScope.setupAssistantVisible = true;
        $scope.currentStep = null;
        $scope.progressingTasks = [];
        $scope.setupAssistant = SETUP_ASSISTANT;
        $scope.setupAssistantFinishLink = URLS.HOME;
        $scope.printer = {
          ipAddress: null,
          type: PRINTER_TYPES.NETWORK
        };
        $scope.printerInputFieldFocusKey = "printerInputFieldFocusKey";
        $scope.isNetworkPrinterCreated = false;
        $scope.setupTodos = ['SHOW_INTRODUCTION', 'DOWNLOAD_CLIENT', 'AWAIT_WORKSTATION', 'AWAIT_INITIAL_DISCOVERY', 'OPEN_DASHBOARD'];
        $scope.eventHandlerService = EventHandlerService;

        (function(){
          initEventHandler();
        })();
        
        function initEventHandler() {
          $scope.eventHandlerService.deRegisterListeners();
        };

        //START DOWNLOAD CLIENT************************************************************************************/
        $scope.apiDownload = APIDownload;

        $scope.downloadClient = function() {
          if (TenantListService.currentTenant.info._embedded.toDos && TenantListService.currentTenant.info._embedded.toDos.length > 0) {
            var downloadCurrentOsClientToDoItem = TenantListService.currentTenant.info._embedded.toDos.findElement({
              action: SETUP_ASSISTANT.DOWNLOAD_CLIENT
            });
            if (downloadCurrentOsClientToDoItem) {
              TenantListService.currentTenant.removeToDoItem(downloadCurrentOsClientToDoItem).then(function() {
                APIDownload.downloadClient();
              }).catch(function(error){});
            } else {
              APIDownload.downloadClient();
            }
          } else {
            throw "$scope.downloadClient: TenantListService.currentTenant.info._embedded.toDos is missing or its length is less than 1";
          }
        };
        //END DOWNLOAD CLIENT**************************************************************************************/

        $scope.checkIfLastElementInList = function(element, list) {
          if (element && list) {
            return list.indexOf(element) === list.length - 1;
          } else {
            throw "$scope.checkIfLastElementInList: element or list are missing";
          }
        };

        $scope.getIntroVideoUrl = function() {
          var translation = (TenantListService.currentTenant && TenantListService.currentTenant.info._embedded.authenticationConfiguration.MSIdentity.enabled) ? "UrlWelcomeVideoMicrosoft" : "UrlWelcomeVideo";
          return $sce.trustAsResourceUrl($filter("translate")(translation));
        };

        $scope.finishIntro = function() {
          if (TenantListService.currentTenant.info._embedded.toDos) {
            var goToDashboardToDoItem = TenantListService.currentTenant.info._embedded.toDos.findElement({
              action: SETUP_ASSISTANT.SHOW_INTRODUCTION
            });
            if (goToDashboardToDoItem) {
              TenantListService.currentTenant.removeToDoItem(goToDashboardToDoItem);
            }
          }
        };

        $scope.addPrinter = function(form, $event) {
          if (form && $event) {
            if (form.$invalid) {
              $event.preventDefault();
            } else {
              form.__customProperties.waitingForAnswer = true;
              PrinterListService.createPrinter($scope.printer).then(function() {
                form.__customProperties.waitingForAnswer = false;
                toastr.success($filter('translate')("WorkingOnIt"));
              }).catch(function(error){
                form.__customProperties.waitingForAnswer = false;
              });
            }
          } else {
            throw "$scope.addPrinter: form or $event are missing";
          }
        };

        $scope.goToDashboard = function() {
          if (TenantListService.currentTenant.info._embedded.toDos) {
            var goToDashboardToDoItem = TenantListService.currentTenant.info._embedded.toDos.findElement({
              action: SETUP_ASSISTANT.OPEN_DASHBOARD
            });
            if (goToDashboardToDoItem) {
              TenantListService.currentTenant.removeToDoItem(goToDashboardToDoItem).then(function() {
                $location.path($scope.setupAssistantFinishLink);
              }).catch(function(error){});
            } else {
              $location.path($scope.setupAssistantFinishLink);
            }
          } else {
            $location.path($scope.setupAssistantFinishLink);
          }
        };

        $scope.closeSetupAssistant = function() {
          TenantListService.currentTenant.options.setupAssistantIsClosed = true;
          deleteSetupTodos();
        };

        function deleteSetupTodos() {
          var todo = TenantListService.currentTenant.info._embedded.toDos.findElement({
            action: $scope.setupTodos[0]
          });

          if (todo) {
            TenantListService.currentTenant.removeToDoItem(todo).then(function(){
              $scope.setupTodos.splice(0, 1);
              if ($scope.setupTodos.length > 0) {
                deleteSetupTodos()
              } else {
                routeToHome();
              }
            }).catch(function(error){});
          } else {
            if ($scope.setupTodos.length > 0) {
              $scope.setupTodos.splice(0, 1);
              deleteSetupTodos()
            } else {
              routeToHome();
            }
          }
        };

        function routeToHome() {
          $location.path(URLS.HOME);
        }
        
        $scope.$on(EventServiceEvents.CHANNELS.ALL_TENANT_USERS.EVENTS.PRINTER_ADDED, function(name, data) {
          $scope.isNetworkPrinterCreated = true;
        });

        $scope.$watch(function() {
          return TenantListService.currentTenant;
        }, function() {
          if (TenantListService.currentTenant) {
            if (TenantListService.currentTenant.info._links["px:toDos"] &&
              TenantListService.currentTenant.info._embedded.toDos &&
              (TenantListService.currentTenant.info._embedded.toDos.findElement({
                  action: SETUP_ASSISTANT.SHOW_INTRODUCTION
                }) ||
                TenantListService.currentTenant.info._embedded.toDos.findElement({
                  action: SETUP_ASSISTANT.DOWNLOAD_CLIENT
                }) ||
                TenantListService.currentTenant.info._embedded.toDos.findElement({
                  action: SETUP_ASSISTANT.AWAIT_WORKSTATION
                }) ||
                TenantListService.currentTenant.info._embedded.toDos.findElement({
                  action: SETUP_ASSISTANT.AWAIT_INITIAL_DISCOVERY
                }) ||
                TenantListService.currentTenant.info._embedded.toDos.findElement({
                  action: SETUP_ASSISTANT.OPEN_DASHBOARD
                }))) {
              if (TenantListService.currentTenant.info._embedded.toDos.findElement({
                  action: SETUP_ASSISTANT.SHOW_INTRODUCTION
                })) {
                $scope.currentStep = SETUP_ASSISTANT.SHOW_INTRODUCTION;
              } else if (TenantListService.currentTenant.info._embedded.toDos.findElement({
                  action: SETUP_ASSISTANT.DOWNLOAD_CLIENT
                })) {
                $scope.currentStep = SETUP_ASSISTANT.DOWNLOAD_CLIENT;
              } else if (TenantListService.currentTenant.info._embedded.toDos.findElement({
                  action: SETUP_ASSISTANT.AWAIT_WORKSTATION
                })) {
                $scope.currentStep = SETUP_ASSISTANT.AWAIT_WORKSTATION;
              } else if (TenantListService.currentTenant.info._embedded.toDos.findElement({
                  action: SETUP_ASSISTANT.AWAIT_INITIAL_DISCOVERY
                })) {
                $scope.currentStep = SETUP_ASSISTANT.AWAIT_INITIAL_DISCOVERY;
              } else if (TenantListService.currentTenant.info._embedded.toDos.findElement({
                  action: SETUP_ASSISTANT.OPEN_DASHBOARD
                })) {
                $scope.currentStep = SETUP_ASSISTANT.OPEN_DASHBOARD;
              }
              $scope.progressingTasks = TenantListService.currentTenant.info._embedded.progressingTasks;
            } else {
              $location.path($scope.setupAssistantFinishLink);
            }
          }
        }, true);

        $scope.$on("$destroy", function() {
          $rootScope.setupAssistantVisible = false;
        });
      }
    ]);
})();